const seoPage = {
  subtitle: 'You can define your SEO meta title and description.',
}

export default seoPage
